import { Navigate, Route, Routes } from 'react-router-dom';

import {
  LoggedType,
  useUserAuthContext,
} from '@/components/AuthTokenContextProvider/UserAuthContext';
import { getPrefixedQueryParamKey } from '@/hooks/useQueryParams';
import Sidebar from '@/pages/admin/components/sidebar';
import { ROUTES } from '@/routes/Routes';
import Layout from '@/ui/Layout/PageLayout';
import { PageLoading } from '@/ui/PageLoading';

import AdminCaseClusterListClient from './components/AdminCaseClusterList/AdminCaseClusterListClient';
import AdminCaseListClient from './components/AdminCaseList/AdminCaseListClient';
import AdminClickupListClient from './components/AdminClickupList/AdminClickupListClient';
import AdminClientListClient from './components/AdminClientList/AdminClientListClient';
import { AdminMasterclassListClient } from './components/AdminMasterclassList/AdminMasterclassListClient';
import AdminMeetingListClient, {
  meetingTablePrefix,
} from './components/AdminMeetingList/AdminMeetingListClient';
import AdminSalesView from './components/AdminSales/AdminSalesView';
import AdminTeamListClient from './components/AdminTeamList/AdminTeamListClient';
import { AdminUserListClient } from './components/AdminUserList/AdminUserListClient';

const AdminPage = () => {
  const { status } = useUserAuthContext();

  if (status !== LoggedType.LOGGED_IN) {
    return <PageLoading />;
  }

  return (
    <Layout>
      <Sidebar>
        <Routes>
          <Route
            path={ROUTES.ADMIN_USER_LIST.replace('admin/', '')}
            element={<AdminUserListClient />}
          />
          <Route
            path={ROUTES.ADMIN_CLIENTS.replace('admin/', '')}
            element={<AdminClientListClient />}
          />
          <Route
            path={ROUTES.ADMIN_TEAMS.replace('admin/', '')}
            element={<AdminTeamListClient />}
          />
          <Route
            path={ROUTES.ADMIN_CASE_LIST.replace('admin/', '')}
            element={<AdminCaseListClient />}
          />
          <Route
            path={ROUTES.ADMIN_MASTERCLASS_LIST.replace('admin/', '')}
            element={<AdminMasterclassListClient />}
          />
          <Route
            path={ROUTES.ADMIN_MEETING_LIST.replace('admin/', '')}
            element={<AdminMeetingListClient />}
          />
          <Route
            path={ROUTES.ADMIN_CASE_CLUSTER_LIST.replace('admin/', '')}
            element={<AdminCaseClusterListClient />}
          />
          <Route
            path={ROUTES.ADMIN_CLICKUP.replace('admin/', '')}
            element={<AdminClickupListClient />}
          />
          <Route path={ROUTES.ADMIN_SALES.replace('admin/', '')} element={<AdminSalesView />} />
          {/* handle default index => users */}
          <Route
            index
            element={
              <Navigate
                to={`${ROUTES.ADMIN_MEETING_LIST}?${getPrefixedQueryParamKey('order', meetingTablePrefix)}=eventDate&${getPrefixedQueryParamKey('orderDir', meetingTablePrefix)}=desc`}
              />
            }
          />
        </Routes>
      </Sidebar>
    </Layout>
  );
};

export default AdminPage;
